<template>
    <v-dialog max-width="500px" v-model="inDialog" env_index persistent>
        <v-card>
            <v-form ref="viewPresentForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formCreateName)
                        }}</v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-select
                                :items="pondAreas"
                                :label="$t('Khu nuôi')"
                                v-model="item.pondAreaId"
                                name="pondAreaId"
                                item-value="categoryId"
                                item-text="categoryCode"
                                v-validate="'required'"
                                :data-vv-as="$t('Khu nuôi')"
                                :error-messages="errors.first('pondAreaId')"
                                @change="onChangeType($event)"
                                :disabled="item.cropId ? true : false"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                :items="item.cropId ? ponds : pondList0"
                                :label="$t('Mã ao')"
                                v-model="item.pondId"
                                name="pondId"
                                item-value="pondId"
                                item-text="code"
                                v-validate="'required'"
                                :data-vv-as="$t('Mã ao')"
                                v-on:input="changePondId"
                                :error-messages="errors.first('pondId')"
                                :disabled="item.cropId ? true : false"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                :items="this.parentCrops()"
                                :label="$t('Mã ao mẹ')"
                                v-model="item.pondParent"
                                name="pondParent"
                                item-value="cropId"
                                item-text="code"
                                :data-vv-as="$t('Mã ao mẹ')"
                                @change="onChangeCropParent($event)"
                                :error-messages="errors.first('pondParent')"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field 
                                :data-vv-as="$t('Mã vụ')"
                                :error-messages="errors.first('code')"
                                :label="$t('Mã vụ')"
                                append-icon="" 
                                disabled
                                name="code"
                                v-model="item.code" 
                                v-validate="''"
                            />
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                              type="text"
                              :label="$t('Tên vụ nuôi')"
                              v-model.trim="item.name"
                              name="name"
                              v-validate="'required'"
                              maxLength="250"
                              :error-messages="errors.first('name')"
                              :data-vv-as="$t('Tên vụ nuôi')"
                          ></v-text-field>
                        </v-flex>
                      <v-flex xs12>
                        <v-text-field
                            :data-vv-as="$t('Số thứ tự vụ')"
                            :error-messages="errors.first('cropNo')"
                            :label="$t('Số thứ tự vụ')"
                            append-icon=""
                            name="cropNo"
                            v-model="item.cropNo"
                            v-validate="'required'"
                        />
                      </v-flex>

                        <!-- <v-flex xs12>
                            <v-text-field
                                type="number"
                                :label="$t('Số lượng giống')"
                                v-model.trim="item.seedNumber"
                                name="seedNumber"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('seedNumber')"
                                :data-vv-as="$t('Số lượng giống')"
                            ></v-text-field>
                        </v-flex> -->
                        <v-flex xs12>
                            <v-select
                                :items="seedNumber"
                                :label="$t('Số lượng giống')"
                                v-model="item.seedNumber"
                                name="seedNumber"
                                item-value="categoryId"
                                item-text="categoryName"
                                v-validate="'required'"
                                :data-vv-as="$t('Số lượng giống')"
                                :error-messages="errors.first('seedNumber')"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                :items="procedureWh"
                                :label="$t('Mã quy trình nuôi')"
                                v-model="item.processId"
                                name="processId"
                                item-value="procedureId"
                                item-text="codeIncludeNote"
                                v-validate="'required'"
                                :data-vv-as="$t('Mã quy trình nuôi')"
                                :error-messages="errors.first('processId')"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-autocomplete
                                :items="staffs"
                                :label="$t('Người nuôi')"
                                v-model="item.users"
                                name="user"
                                item-value="userId"
                                item-text="fullName"
                                v-validate="'required'"
                                :data-vv-as="$t('Người nuôi')"
                                :error-messages="errors.first('user')"
                                multiple
                                clearable
                            />
                        </v-flex>
                        <v-flex xs12>
                            <i-datepicker 
                                :label="$t('lang.common.startDate')"
                                v-model="item.startDate"
                                :disabled="item.cropId ? true : false"
                                :v-validate="'required'"
                                :error-messages="errors.first($t('lang.common.startDate'))"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <i-datepicker 
                                :label="$t('Ngày thả giống/sang tôm')"
                                v-model="item.dropDate"
                                :defaultValue="item.dropDate ? true : false"
                                :minDate="checkMinDate(item.startDate)"
                                @clearText="clearDropDate"
                                clearable
                            />
                        </v-flex>
                        <v-flex xs12>
                            <i-datepicker 
                                :label="$t('lang.common.endDate')"
                                v-model="item.endDate"
                                :defaultValue="item.endDate ? true : false"
                                :minDate="checkMinDate2()"
                                clearable
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                :items="areaStatus"
                                :label="$t('Trạng thái')"
                                v-model="item.status"
                                name="status"
                                item-value="value"
                                item-text="text"
                                :data-vv-as="$t('Trạng thái')"
                                :error-messages="errors.first('status')"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{ $t("lang.common.save") }}
                </v-btn>
                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.cancel") }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { message } from "../../../services";
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import { areaContants } from "@/constants";
// import commonMixin from "@/mixins/commonMixin";

export default {
    name: "crop-create",
    components: { message, axios, IDatepicker },
    props: {
        propsItem: {
            type: Object,
            default: () => {
                return {}
            }
        },
        cDialog: {
            type: Boolean,
            default: false,
        },
        ponds: {
            type: Array,
            default: [],
        },
        pondList0: {
            type: Array,
            default: [],
        },
        pondAreas: {
            type: Array,
            default: [],
        },
        users: {
            type: Array,
            default: [],
        },
        staffs: {
            type: Array,
            default: [],
        },
        crops: {
            type: Array,
            default: [],
        },
        seedNumber: {
            type: Array,
            default: [],
        },
        procedureWh: {
            type: Array,
            default: [],
        },
        formCreateName: {
            type: String,
            default: '',
        },
    },
    data: () => {
        return {
            formName: "Cập nhật vụ nuôi",
            showStartDate: false,
            showEndDate: false,
            defaultUser: '',
            areaStatus: areaContants.areaStatus,
            item: {
                name: "",
                code: "",
                pondId: '',
                pondParent: '',
                pondAreaId: '',
                processId: '',
                seedNumber: '',
                users: "",
                status: 1,
                endDate: "",
                startDate: moment().format('YYYY-MM-DD'),
                dropDate: "",
                dropDateParent: "",
                shrimpAge: 0,
                currentNo: '',
            },
            inDialog: false,
            pondIds: [],
        };
    },
    watch: {
        propsItem: {
            handler(value) {
                if (value !== null) {
                    if (value.users.length > 0 && typeof value.users == 'string') {
                        const items = [];
                        // console.log(value.users, value.users.split(","));
                        const uArr = value.users.split(",");
                        uArr.forEach((v) => {
                            items.push(parseInt(v));
                        });
                        // console.log(items);
                        // this.defaultUser = items;
                        value.users = items;
                    }
                    this.item = {
                        cropId: value.cropId,
                        name: value.name ? value.name : "",
                        code: value.code ? value.code : "",
                        pondId: value.pondId ? value.pondId : 0,
                        pondParent: value.pondParent ? value.pondParent : 0,
                        pondAreaId: value.pondAreaId ? value.pondAreaId : 0,
                        processId: value.processId ? value.processId : 0,
                        seedNumber: value.seedNumber ? value.seedNumber : 0,
                        users: value.users ? value.users : "",
                        status: value.status ? value.status : 0,
                        shrimpAge: value.shrimpAge ? value.shrimpAge : 0,
                        startDate: moment(String(value.startDate)).format('YYYY-MM-DD'),
                        endDate: value.endDate ? moment(String(value.endDate)).format('YYYY-MM-DD') : '',
                        dropDate: value.dropDate ? moment(String(value.dropDate)).format('YYYY-MM-DD') : '',
                        dropDateParent: value.dropDateParent ? moment(String(value.dropDateParent)).format('YYYY-MM-DD') : '',
                        currentNo: value.currentNo ? value.currentNo : "",
                        cropNo: value.cropNo ? value.cropNo : "",
                    };
                } else {
                    this.resetFrom();
                }
            },
            deep: true,
        },
        cDialog(value) {
            this.inDialog = value;
        },
        inDialog (value) {


            if(!value){

                this.$emit("closeCreateDialog", "");
            }
        },
    },
    methods: {
        resetFrom: function () {
            this.item = {
                name: "",
                code: "",
                pondId: '',
                pondParent: '',
                pondAreaId: '',
                processId: '',
                seedNumber: '',
                users: "",
                status: 1,
                endDate: "",
                startDate: moment().format('YYYY-MM-DD'),
                dropDate: "",
                dropDateParent: "",
                shrimpAge: 0,
                currentNo: '',
            };
        },
        onCancel: function () {
            this.$emit("closeCreateDialog", "");
        },
        changePondId: function (pondId) {
            for (let i = 0; i < this.pondIds.length; i++) {
                if (this.pondIds[i].id == pondId) {
                    this.item['code'] = this.pondIds[i].cropCode;
                    this.item['name'] = this.pondIds[i].cropCode;
                    this.item['currentNo'] = this.pondIds[i].procedureNextNo;
                    this.item['currentYear'] = this.pondIds[i].procedureYear;
                    break;
                }
            }
        },
        reloadNumberCrop() {
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/pond", {}).then(
                data => {
                    this.pondIds = data.items
                }
            )
        },
        onSave: function () {
            // console.log(this.item);
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }

                const item_tmp = this.item;
                
                if (item_tmp.users.length > 0 && typeof item_tmp.users == 'object') {
                    item_tmp.users = item_tmp.users.join();
                }
                
                let startDate = moment(String(item_tmp.startDate));
                let endDate = moment(String(item_tmp.endDate));
                let dropDate = moment(String(item_tmp.dropDate));
                
                if (item_tmp.dropDate != '' && item_tmp.dropDate != null) {
                    if (dropDate <= startDate) {
                        message.error(this.$t("Ngày thả giống/sang tôm phải sau Ngày bắt đầu"));
                        return;
                    }
                    if (item_tmp.endDate != '' && item_tmp.endDate != null) {
                        if (endDate <= dropDate) {
                            message.error(this.$t("Ngày kết thúc phải sau Ngày thả giống/sang tôm"));
                            return;
                        }
                    }
                }
                if (item_tmp.endDate != '' && item_tmp.endDate != null) {
                    if (endDate <= startDate) {
                        message.error(this.$t("Ngày kết thúc phải sau Ngày bắt đầu"));
                        return;
                    }
                }
                
                // return;
                axios
                    .post(process.env.VUE_APP_API_URL + "/crop/save", item_tmp)
                    .then(
                        (data) => {
                            if (data.success) {
                                message.success(
                                    this.$t("lang.common.save_success")
                                );
                                this.resetFrom();
                                this.onCancel();
                                this.reloadNumberCrop();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            });
        },
        onChangeType(event) {
            this.$emit("getPondList", event);
            this.$emit("getCropList", event);
            this.getProcedureWh();
        },
        // onChangeSeedNumber(event) {
        //     this.getProcedureWh();
        // },
        getProcedureWh() {
            // const item = this.seedNumber.find(o => o.categoryId === this.item.seedNumber );
            const params = {
                areaId: this.item.pondAreaId,
            };
            // if (item !== undefined) {   
            //     params.seedNumber = item.categoryName;
            // }
            this.$emit("getProcedureWh", params);
        },
        onChangeCropParent(event) {
            const item = this.crops.find(o => o.cropId === event );
            if (item !== undefined && typeof item == 'object' && item.dropDate != '') {
                let dropDate = moment(String(item.dropDate)).format('YYYY-MM-DD');
                if (dropDate != "Invalid date") {
                    this.item.dropDateParent = dropDate;
                }
            }
        },
        checkMinDate(minDate = moment()) {
            if (minDate == '' || minDate == null) minDate = moment();
            let minDate_tmp = moment(String(minDate));
            let today = moment();
            // if (minDate_tmp <= today) {
            //     minDate = moment().format('YYYY-MM-DD');
            // } else {
                minDate = minDate_tmp.format('YYYY-MM-DD');
            // }
            return minDate;
        },
        checkMinDate2() {
            const startDate = this.item.startDate;
            const dropDate = this.item.dropDate;
            let minDate = moment();
            
            if (startDate != '' && startDate != null) {
                minDate = startDate;
            }
            if (dropDate != '' && dropDate != null) {
                minDate = dropDate;
            }
           
            if (minDate == '' || minDate == null) minDate = moment();
            let minDate_tmp = moment(String(minDate));
            minDate = minDate_tmp.format('YYYY-MM-DD');
            
            return minDate;
        },
        parentCrops() {
            const item_tmp = this.item;
            let parents = [];
            if (item_tmp.cropId && this.crops.length > 0) {
                parents = this.crops.filter(function (v) {
                    return v.cropId != item_tmp.cropId;
                });
            } else {
                parents = this.crops.filter(function (v) {
                    return !(parseInt(v.pondParent) > 0);
                });
            }
            return parents;
        },
        clearDropDate() {
            this.item.dropDate = '';
        }
    },
    created() {
       this.reloadNumberCrop();
    },
};
</script>
